// extracted by mini-css-extract-plugin
export default {"main":"AddShipping_main__TzZFh","body":"AddShipping_body__1W4Tp","list":"AddShipping_list__d-QM7","btn":"AddShipping_btn__wyQcR","header":"AddShipping_header__3xAbD"};